module.exports = __webpack_public_path__ + "img/Mockup1.7b656b96.webp";